import "../../styles/components/shoppingCart/shoppingCartQuantityInputComponent.scss";

export const ShoppingCartQuantityInputComponent = ({ props }) => {
  const { cartItem, handleAdd, handleReduce } = props;

  const handleAddClicked = (event) => {
    event.preventDefault();
    handleAdd(cartItem);
  };

  const handleReduceClicked = (event) => {
    event.preventDefault();
    handleReduce(cartItem);
  };

  return (
    <div className="shoppingCartQuantityInputContainer">
      <button className="quantityButton" onClick={handleAddClicked}>
        +
      </button>
      <input className="quantityInput" type="number" min={0} value={cartItem?.quantity} readOnly/>
      <button className="quantityButton" onClick={handleReduceClicked}>
        -
      </button>
    </div>
  );
};

export default ShoppingCartQuantityInputComponent;
